module.exports = __webpack_public_path__ + "static/media/jaels-creations-desktop-header.843f588f.jpg";